import $ from 'jquery'
import CookieConsentManager from '../cookie_consent_manager'
import Notification from '@toolkit/components/notification'

$(function () {
  const cookieConsentRequired =
    $('meta[name=cookie-consent-required]').length

  if (!cookieConsentRequired) { return }

  const copy =
'<div class=\'component-notification__header\'>Accept our Cookie Policy</div> This website and its third-party tools use cookies. Learn more about why these are required in our <a class="privacy-policy" href="/privacy-policy">Privacy Policy</a>. By continuing to browse, you accept the use of cookies.'

  const toast = new Notification({
    mode: 'toast',
    autoHideAfter: -1,
    primaryLabel: 'Agree'
  })

  toast.render()
  toast.$el.css('top', 'auto')
  toast.$el.css('bottom', '1em')

  $('body').append(toast.render().$el)

  toast.notice(copy)

  const trackEvent = (event) => {
    if (!window.cutlassCannon) { return }
    window.cutlassCannon.addEvent(`cookie_banner:${event}`)
  }

  const explicitAgree = () => {
    CookieConsentManager.explicitAgree()
    toast.remove()
    trackEvent('explicit_agree')
  }

  const implicitAgree = () => {
    CookieConsentManager.implicitAgree()
    toast.remove()
    trackEvent('implicit_agree')
  }

  const dismiss = () => {
    toast.remove()
    trackEvent('dismiss')
  }

  toast.on('click:primary', explicitAgree)
  toast.on('click:dismiss', dismiss)

  $('button').click(function () {
    if (this.getAttribute('name') === 'dismiss') { return }
    implicitAgree()
  })
})
